import { openBlock as t, createElementBlock as r, createElementVNode as n } from "vue";
import { _ as o } from "./_plugin-vue_export-helper-dad06003.js";
const i = {}, l = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(s, e) {
  return t(), r("svg", l, e[0] || (e[0] = [
    n("path", {
      d: "M6 12L10 8L6 4",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const x = /* @__PURE__ */ o(i, [["render", c]]), a = {}, d = {
  id: "loader-1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "40px",
  height: "40px",
  viewBox: "0 0 50 50",
  style: { "enable-background": "new 0 0 50 50" },
  "xml:space": "preserve"
};
function p(s, e) {
  return t(), r("div", null, [
    (t(), r("svg", d, e[0] || (e[0] = [
      n("path", {
        fill: "currentColor",
        d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      }, [
        n("animateTransform", {
          attributeType: "xml",
          attributeName: "transform",
          type: "rotate",
          from: "0 25 25",
          to: "360 25 25",
          dur: "0.6s",
          repeatCount: "indefinite"
        })
      ], -1)
    ])))
  ]);
}
const f = /* @__PURE__ */ o(a, [["render", p]]);
export {
  x as C,
  f as P
};
